const autoNgTemplateLoaderTemplate1 = require('./HeaderContent.html');

import { PropsWithChildren } from 'react';
import clsx from 'clsx';

import { Link } from '@/core/components/Link';
import { useUser } from '@/core/hooks/useUser';

import controller from './HeaderContent.controller';
import styles from './HeaderContent.module.css';
import { useHeaderContext } from './HeaderContainer';
import { LanguageSwitcher } from './LanguageSwitcher';

export function HeaderContent({ children }: PropsWithChildren<unknown>) {
  useHeaderContext();
  const { user } = useUser();

  return (
    <div className="breadcrumb-links">
      <div className="pull-left">{children}</div>
      {user && (
        <div className={clsx('pull-right', styles.userLinks)}>
          <LanguageSwitcher />
          <Link to="shbdeployer.account" className={styles.link}>
            <i
              className={clsx('fa fa-wrench', styles.linkIcon)}
              aria-hidden="true"
            />
            <span className={styles.linkText}>Мой профиль</span>
          </Link>
          <Link
            to="shbdeployer.logout"
            params={{ performApiLogout: true }}
            className={clsx('shb-header__logout', styles.link)}
            data-cy="template-logoutButton"
          >
            <i
              className={clsx('fa fa-sign-out-alt', styles.linkIcon)}
              aria-hidden="true"
            />
            <span className={styles.linkText}>Выйти</span>
          </Link>
        </div>
      )}
    </div>
  );
}

export const HeaderContentAngular = {
  requires: '^rdHeader',
  transclude: true,
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
